var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.942 17.242a.836.836 0 1 0-.142 1.666c1.055.076 2.105.221 3.142.434a.208.208 0 0 1 0 .408 33.2 33.2 0 0 1-6.942.583 33.2 33.2 0 0 1-6.942-.591.208.208 0 0 1 0-.409 24 24 0 0 1 3.109-.433.833.833 0 0 0-.142-1.658C2 17.75 2 19 2 19.5 2 21.725 8.933 22 12 22s10-.242 10-2.5c0-.5 0-1.75-6.058-2.258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 20a.83.83 0 0 0 .7-.383c1.667-2.55 5.433-8.775 5.433-11.484a6.133 6.133 0 0 0-12.266 0c0 2.709 3.8 8.934 5.433 11.484A.83.83 0 0 0 12 20M9.083 7.833a2.917 2.917 0 1 1 5.834 0 2.917 2.917 0 0 1-5.834 0"
  })));
};
export default SvgLocation;